import React,{useState, useEffect} from 'react'
import { withRouter } from 'react-router-dom';
import {Box,Heading,Layer,Text,Button} from 'grommet';
import {Close, Notes,Redo,Revert} from 'grommet-icons';
import GetShipmentDocuments from '../../components/getShipmentDocuments'
import GetS3Document from '../../components/getS3Document'
import { LoadLayer, NavigationSnackBar, ReturnRowDir,isShipmentCollected } from '../../components/utils/shared/shared';
import { ReturnLocation,ReturnCollectionDetails,ShipmentSuccessNotification } from '../../components/utils/shared/shipmentViewFunctions';
import ShipmentTrackingDetails from '../../components/shipmentTrackingDetails'
import { APIRequest } from '../../components/utils/shared/requests';
import { API,Auth } from 'aws-amplify';

function CancelShipment(props){
  const confirmCancellation = (shipment) => {
    props.setLoad(true)
    Auth.currentSession().then(session => {
      API.get("LabShip", `/cancel_shipment?shipment=${props.shipment.id}`,{headers: {Authorization: session.idToken.jwtToken,}})
        .then(
          (result) => {
            console.log(result)
            if (result.status === 'success'){
              props.setLoad(false)
              props.setCancelOpen(undefined)
              // setShowTrackingOverlay(true)
              // props.setShipment(result.shipment)
              props.props.history.push({pathname: `/shipment/${props.shipment.id}`, reload:true, cancelSuccess:true})
            } else {
             return
            }
          },
          (error) => {
            console.log(error);
          }
        );
    })
  }
  if (props.cancelOpen){
    return (
      <Layer onEsc={() => {props.setCancelOpen(false)}}>
        <Box width={'large'} >
          <Box justify='center' margin='small'><Text alignSelf='center' weight={'bold'}>Are you sure you wish to cancel this shipment?</Text></Box>
          <Box justify='center' margin='small'><Text alignSelf='center'>AWB: {props.shipment.awb_number}</Text></Box>
          <Box justify='center' margin='small'><Text size='small' weight='bold' alignSelf='center'>Please note this is not guarenteed to cancel your shipment or collection if enough notice is not provided. </Text></Box>
          <Box justify='center' margin='small' direction='row'><Button onClick={() => {props.setCancelOpen(undefined)}} icon={<Revert />} margin={'small'} size='small' primary label='Close'/><Button margin='small' icon={<Close />} onClick={() => {confirmCancellation(props.shipment)}} primary size='small' color='status-critical' label='Cancel Shipment'/></Box>
        </Box>
      </Layer>
    )
  }

}

function ShipmentViewCardHeader(props){
  // const page = (props.props.location.state === undefined ? 1 : props.props.location.state.page)
  // const startIndex = (props.props.location.state === undefined ? 1 : props.props.location.state.startIndex)
  // const endIndex = (props.props.location.state === undefined ? 10 : props.props.location.state.endIndex)
  if (props.props.user === 'SuperAdmin'){
    // <Link to="/admin/shipments/all" search={`page=${page}`} state={{startIndex: startIndex,endIndex: endIndex}}><Button secondary hoverIndicator icon={<FormPrevious color={'brand'} />} /></Link>
    return (
      <Box justify='between' direction='row'><Box><Button disabled={isShipmentCollected(props.shipment)} onClick={() => {props.setCancelOpen(true)}} color='status-critical' icon={<Close />} hoverIndicator style={{zIndex: 10}} primary size='small' label='Cancel Shipment' /></Box><Box><Button hoverIndicator style={{zIndex: 10}} primary onClick={() => {props.props.history.push({pathname: '/shipment/new', reship:true, origin: props.shipment.origin, destination: props.shipment.destination, details:props.shipment.pieces})}}  size='small' label='Reship' icon={<Redo />}/></Box></Box>
    )
  } else {
    return (
      <Box margin={'small'} justify='between' direction='row'><Box><Button hoverIndicator style={{zIndex: 10}} primary onClick={() => {props.props.history.push({pathname: '/shipment/new', reship:true, origin: props.shipment.origin, destination: props.shipment.destination, details:props.shipment.pieces})}}  size='small' label='Reship' icon={<Redo />}/></Box></Box>

    )
  }
}

function ViewShipment(props) {    
  const [shipment, setShipment] = useState()
  const [load, setLoad] = useState(true)
  const [cancelOpen, setCancelOpen] = useState(undefined)
  const [cancelSucc, setCancelSucc] = useState(undefined)
  useEffect(() => { 
    if(props.location.reload){
      setCancelSucc(true);
      setTimeout(() => {
        setCancelSucc(undefined);
    }, 5000)
    }
     APIRequest(`/shipments/${props.match.params.shipment_id}`).then(result => {setShipment(result); setLoad(false)})
   },[props]);
    return (
      <Box background={'light-2'}>
      <NavigationSnackBar title={`Shipment ${props.match.params.shipment_id}`} user={props.user} pages={[{name: 'Dashboard', link: '/dashboard'},{name: 'All Shipments', link: '/shipments/all'}]}  />
            {(load ? <LoadLayer load={load} label={'Loading...'}/>:
            <Box margin='small'>          
            {cancelSucc && (<ShipmentSuccessNotification label={"Shipment"} method={"cancelled"}/>)}
            <ShipmentViewCardHeader shipment={shipment} props={props} cancelOpen={cancelOpen} setCancelOpen={setCancelOpen} />
            <CancelShipment cancelOpen={cancelOpen} setCancelOpen={setCancelOpen} shipment={shipment} props={props} load={load} setLoad={setLoad} />
              <Box direction={ReturnRowDir(props.size)} margin='small' justify='between'><ReturnLocation location={shipment.origin} locationType={"Origin"} /><ReturnCollectionDetails shipment={shipment} props={props} setShipment={setShipment} /> <ReturnLocation location={shipment.destination} locationType={"Destination"} />  </Box>
                <Box direction='row' alignSelf='center' margin='small' overflow='scroll'>
                <ShipmentTrackingDetails user={props.user} shipment={shipment} displayQuote={props.displayQuote} setShipment={setShipment} />
                </Box>
              <Box pad='small' margin='small' round elevation='medium' background={'background-front'}>
                <Box direction='row'><Notes color='brand' margin='small' /><Heading margin='small' level={4}>Documents</Heading></Box>
                <GetShipmentDocuments shipment={shipment} />
                <GetS3Document CommodityID={shipment.pieces.Packages[0].CommodityID} />
              </Box>
              </Box>

            )}
         </Box>
    )
  }

export default withRouter(ViewShipment)
